module.exports = __webpack_public_path__ + "static/media/publish_project.7eb35f5b.svg";